import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapViewComponent } from './views/map-view/map-view.component';
import { WelcomeDialogViewComponent } from './views/welcome-dialog-view/welcome-dialog-view.component';
import { DeviceTypeGuard } from './guards/device-type-guard.module';
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'map',
    component: MapViewComponent,
    canActivate: [DeviceTypeGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    component: WelcomeDialogViewComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
